export function removeNull<T>(arg: T): Exclude<T, null> | undefined {
  return (arg == null ? undefined : arg) as (Exclude<T, null> | undefined)
}

